<div class="hero-container">
  <div class="sectio" [ngClass]="(sliders.length == 0)?'is-hero':'hero'">
  <div class="is-hero-categories" *ngIf="sliders.length == 0" [ngClass]=" (!loadingBenefits && !loadingCategories)?'':'cargandoHero'">
    <swiper #swiperHero [config]="config" class="static-img-desktop">
      <ng-template swiperSlide *ngFor="let item of items">
        <img [src]="item.imgUrl" class="banner" alt="banner">
      </ng-template>
    </swiper> 
    <swiper #swiperHero [config]="config" class="static-img-mobile">
      <ng-template swiperSlide *ngFor="let item of itemsMobile">
        <img [src]="item.imgUrlMobile" class="banner" alt="banner">
      </ng-template>
    </swiper>     
  </div>
  
  <swiper #swiperHero [config]="sliders.length > 1 ? configBenefits : {} " *ngIf="sliders.length > 1" class="swiper-benefits">
    <ng-template swiperSlide  *ngFor="let item of sliders">
      <app-slider [item]="item"></app-slider>
    </ng-template>
  </swiper>
  
  <swiper #swiperHero [config]="sliders.length === 1 ? config : {} " *ngIf="sliders.length === 1" class="swiper-benefits">
    <ng-template swiperSlide *ngFor="let item of sliders">
      <app-slider [item]="item"></app-slider>
    </ng-template>
  </swiper>
  <div class="btn-container">
    <div *ngIf="sliders.length > 1" (click)="slideNext()" class="swiper-button-next"></div>
    <div *ngIf="sliders.length > 1" (click)="slidePrev()" class="swiper-button-prev"></div>
  </div>
</div>

<div class="categories-swipper">
    <div>
      <swiper #swiperCategories [config]="configCategories" class="categories-swiper">
        <ng-container *ngFor="let item of categories">
          <ng-template swiperSlide>
            <div class="categories-container">
              <div class="categories-items">
                <a [href]="'/beneficios-y-descuentos/' + item.redirect" class="col-12">
                  <div class="img-category">
                    <img [src]="item.photo" alt="">
                    <h2>{{ item.name }}</h2>
                  </div>
                </a>
              </div>
            </div>
          </ng-template>
        </ng-container>
      </swiper>
    </div>
    <div class="btn-container-categories">
      <div (click)="slidePrevCategories()" class="swiper-button-prev swiper-button-prev-categories"></div>
      <div (click)="slideNextCategories()" class="swiper-button-next swiper-button-next-categories"></div>
    </div>
</div>

<div class="section is-filters">
  <div class="container is-filters">
    <div class="col-2">
      <app-benefits-filter 
        *ngIf="showFilterMobile" 
        (closeFilter)="hideMobileFilter()" 
        (filtersUsed)="onFiltersUsed($event)">
      </app-benefits-filter>
    </div>     

  <div class="col-9 benefit-section">
    <div class="sort-container">
      <div class="sort">
        <div class="section is-search-bar">
          <div class="search-container">
            <div class="search-input">
              <form (submit)="applyKeywordFilter()">
                <div class="form-group">
                  <img src="../../../assets/icon/icon-search.svg" alt="">
                  <input [value]="keywords" (keyup)="onKeywordChange($event)" class="form-control" placeholder="¿Qué estas buscando?">
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="menu-mobile">
          <img class="open_menu" src="../../../assets/icon/icon-menu-mobile.svg" (click)="showMobileFilter()">
          <span *ngIf="filtersCount > 0" >{{ filtersCount }} filtros</span>
        </div>
        <div class="filter-options">
          <span>Ordenar por</span>
          <select (change)="selectOrder($event)" class="order-options">
            <option *ngFor="let option of orders" [value]="option.id" [selected]="ord_data === option.id"> {{option.label}} </option>
          </select>
        </div>
      </div>
    </div>
  
    <div class="col-12">
      <section class="benefits">
        <p class="benefits-count" *ngIf="!loadingBenefits"> {{displayedBenefits.length}} Beneficios </p>
        <div class="map-area" *ngIf="!toggle">
          <div #mapContainer id="map"></div>
        </div>
        <ul *ngIf="toggle" class="thumb-benefits col-6">
          <ng-container *ngIf="!loadingBenefits else showBenefits">
            <p class="noBenefitsText" *ngIf="displayedBenefits.length == 0">{{waitText}}</p>
            <li *ngFor="let item of displayedBenefits" class="wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.2s">
                <app-benefit-box [item]="item" [isBenefitPage]="true"> </app-benefit-box>
            </li>
          </ng-container>
          <ng-template #showBenefits>
            <p>Cargando...</p>
          </ng-template>
        </ul>
      </section>
    </div>
  </div>
  </div>
</div>

</div>
